import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Flag } from "lucide-react";
import ReportModal from "@/components/ReportModal";

/**
 * "Flag for review" control. Opens the shared report modal (selectable reason
 * buttons + a free-text box) and POSTs to /flags. Works for board posts/replies
 * and listings (team/trainer/event/trainer_listing).
 */
export default function FlagButton({ targetType, targetId, label = "Flag", testid }) {
    const { user } = useAuth();
    const [open, setOpen] = useState(false);
    if (!user) return null;

    return (
        <>
            <button
                type="button"
                data-testid={testid || `flag-${targetType}-btn`}
                onClick={() => setOpen(true)}
                className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] text-[#a0a0a0] hover:text-red-500 transition-colors"
                title="Flag for review"
            >
                <Flag className="h-3 w-3" /> {label}
            </button>
            <ReportModal open={open} onClose={() => setOpen(false)} targetType={targetType} targetId={targetId} />
        </>
    );
}
